
		import Async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function (require) {
				cb( require("!!../../../../../.nvm/versions/node/v6.10.0/lib/node_modules/preact-cli/node_modules/babel-loader/lib/index.js??ref--0!./index.js") );
			}, "route-404");
		}

		export default Async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/404/index.js
// module id = null
// module chunks = 